import InnoSite from './InnoSite';

function App() {
  return (
    <InnoSite />
  );
}

export default App;
